import { Component, EventEmitter, Output } from '@angular/core';
import { CHECKOUT_MATOMO_EVENT_CATEGORY_PERSONALIZATION } from '@platform-frontend/checkout';

@Component({
  selector: 'yat-button-add-person',
  templateUrl: './button-add-person.component.html',
  styleUrls: ['./button-add-person.component.scss']
})
export class ButtonAddPersonComponent {
  @Output()
  addPerson = new EventEmitter<void>();

  readonly MATOMO_EVENT_CATEGORY_PERSONALIZATION = CHECKOUT_MATOMO_EVENT_CATEGORY_PERSONALIZATION;

  onAddPersonClick(): void {
    this.addPerson.emit();
  }
}
